var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Load_ring"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Load_ring",
    "data-name": "Load ring",
    clipPath: "url(#clip-Load_ring)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M995.992,1478.693c-110.278,0-200-89.719-200-200s89.721-200,200-200,200,89.721,200,200S1106.272,1478.693,995.992,1478.693Zm0-375.894C899,1102.8,820.1,1181.707,820.1,1278.694S899,1454.587,995.992,1454.587s175.895-78.906,175.895-175.893S1092.981,1102.8,995.992,1102.8Z",
    transform: "translate(-795.993 -1078.693)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M994.548,1395.012c-108.381,0-196.555-88.175-196.555-196.555a8.609,8.609,0,0,1,17.219,0c0,98.886,80.45,179.337,179.337,179.337a8.609,8.609,0,1,1,0,17.219Z",
    transform: "translate(-794.549 -998.456)",
    fill: "#146fdb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadRing);
export default __webpack_public_path__ + "static/media/load_ring.0ddad0c403b381600e8382de372b0958.svg";
export { ForwardRef as ReactComponent };